import { env } from '../config.js';

export async function shareExperiment(token, id, targetUserMail, rights) {
    var data = {targetUserMail: targetUserMail, rights: rights};
    const response = await fetch(env.BACKEND_URL + '/experiments/share/' + id,
    {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data)
    });
    return await response;
}

export async function listSharedExperiments(token, page = 0) {
    const response = await fetch(env.BACKEND_URL + '/experiments/share?page=' + page + '&sort=experiment.id,ASC',
    {
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    return await response.json();
}

export async function listSharedRecords(token, id) {
    const response = await fetch(env.BACKEND_URL + '/experiments/share/users/' + id,
    {
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    return await response.json();
}

export async function updateSharedRecord(token, recordId, rights) {
    var data = {rights: rights};
    const response = await fetch(env.BACKEND_URL + '/experiments/share/' + recordId,
    {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data)
    });
    return await response;
}

export async function deleteSharedRecord(token, recordId) {
    const response = await fetch(env.BACKEND_URL + '/experiments/share/' + recordId,
    {
        method: 'DELETE',
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    return await response;
}

